import getQueryVariable from './GetQueryVariable';

export default function(type, slug) {
    let head = {};
    let api = `${type}?slug=${slug}`;
    console.log(type)

    if (getQueryVariable('preview_id')) {
        head.headers = {
            'Content-Type': 'application/json',
            'X-WP-Nonce': window.globals.node
        };
        head.credentials = 'include';
        api = `${type}/${getQueryVariable('preview_id')}/revisions`

        if (getQueryVariable('_thumbnail_id') !== null) {
            api = api + '?image_id=' + getQueryVariable('_thumbnail_id');
        }
    }

    return {
        head: head,
        url: api,
    }
}
